import { Injectable } from '@angular/core';
import {
  Rppk16CardRow,
  Rppk16ClientGroup,
  Rppk16TableResult,
  Rppk16Totals,
  Rppk16VehicleTypeGroup,
} from '../../models/report/rppk16.model';

@Injectable({ providedIn: 'root' })
export class MapperRppk16Service {
  mapTable(res: unknown): Rppk16TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      groups: groups.map((g) => this.mapClientGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapClientGroup(dto: unknown): Rppk16ClientGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const vehicleTypes = (g['vehicleTypes'] ?? g['VehicleTypes'] ?? []) as unknown[];
    return {
      clientId: Number(g['clientId'] ?? g['ClientId'] ?? 0),
      clientName: String(g['clientName'] ?? g['ClientName'] ?? ''),
      cardCount: Number(g['cardCount'] ?? g['CardCount'] ?? 0),
      vehicleTypes: vehicleTypes.map((v) => this.mapVehicleTypeGroup(v)),
    };
  }

  private mapVehicleTypeGroup(dto: unknown): Rppk16VehicleTypeGroup {
    const v = (dto ?? {}) as Record<string, unknown>;
    const cards = (v['cards'] ?? v['Cards'] ?? []) as unknown[];
    return {
      vehicleTypeId: Number(v['vehicleTypeId'] ?? v['VehicleTypeId'] ?? 0),
      vehicleTypeName: String(v['vehicleTypeName'] ?? v['VehicleTypeName'] ?? ''),
      cardCount: Number(v['cardCount'] ?? v['CardCount'] ?? 0),
      cards: cards.map((c) => this.mapCard(c)),
    };
  }

  private mapCard(dto: unknown): Rppk16CardRow {
    const c = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(c['seq'] ?? c['Seq'] ?? 0),
      cardId: Number(c['cardId'] ?? c['CardId'] ?? 0),
      cardName: String(c['cardName'] ?? c['CardName'] ?? ''),
      fullName: String(c['fullName'] ?? c['FullName'] ?? ''),
      licenses: String(c['licenses'] ?? c['Licenses'] ?? ''),
      subscriptionName: String(c['subscriptionName'] ?? c['SubscriptionName'] ?? ''),
      issueDate: (c['issueDate'] ?? c['IssueDate'] ?? null) as string | null,
      expireDate: (c['expireDate'] ?? c['ExpireDate'] ?? null) as string | null,
    };
  }

  private mapTotals(dto: unknown): Rppk16Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      cardCount: Number(t['cardCount'] ?? t['CardCount'] ?? 0),
    };
  }
}
